/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  TextField,
  Typography,
  Tooltip,
  Paper,
  Autocomplete,
} from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import Message from "../../../utils/Message";
import {
  getPersonaById,
  getPersonaHistoryById,
} from "../../../services/PersonaFisicaService";
import { useNavigate, useParams } from "react-router-dom";
import { KeyboardReturn, Save, Visibility } from "@mui/icons-material";
import { useLocation } from 'react-router-dom';
import DocumentosDialog from "../Dialogs/DocumentosDialog";
import TelefonosDialog from "../Dialogs/TelefonosDialog";
import ProfesionesDialog from "../Dialogs/ProfesionesDialog";
import DomiciliosDialog from "../Dialogs/DomiciliosDialog";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';


const initialSearchData = {
  apellido: "",
  nombre: "",
  alias: "",
  sexo_registrado_nacimiento: "",
  genero: "",
  nacionalidad: "",
  documentos: "",
  tipoDocumento: "",
  numeroDocumento: "",
  fecha_nacimiento: "",
  fecha_fallecimiento: "",
  cuil: "",
  cuit: "",
  email: "",
  telefonos: "",
  estadoCivil: "",
  domicilios: "",
  profesiones: "",
  telefono: "",
  domicilio: "",
  estado_civil: "",
  fecha_actualizacion: "",
};

let nameItemsText = "Historial de Persona Fisica";
//
// ############################################################################# 
//
const PersonaFisicaHistorial = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [Personas, setPersona] = useState([]);
  const [Personaselected, setPersonaelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [valueAutoCompleteMedioDeCobro, setValueAutoCompleteMedioDeCobro] =
    useState({ id: "", label: "" });
  const [
    inputValueAutoCompleteMedioDeCobro,
    setInputValueAutoCompleteMedioDeCobro,
  ] = useState("");
  const [tipoMovimiento, setTipoMovimiento] = useState("todos");
  const [disabledtipoMovimiento, setDisabledtipoMovimiento] = useState(false);
  const [valueAutoCompleteObraSocial, setValueAutoCompleteObraSocial] = useState(
    { id: "", descripcion: "" });
  const [inputValueAutoCompleteObraSocial, setInputValueAutoCompleteObraSocial] = useState("");
  const [valueAutoCompleteObraSocialPlan, setValueAutoCompleteObraSocialPlan] = useState({
    id: "",
    descripcion_obra_social_plan: "",
    id_obra_social: ""
  })
  const [inputValueAutoCompleteObraSocialPlan, setInputValueAutoCompleteObraSocialPlan] = useState("");
  const [obraSocialPlanesTmp, setObraSocialPlanesTmp] = useState([]);
  const params = useParams();
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [codigoPersona, setCodigoPersona] = useState('')
  const [estadoPersona, setEstadoPersona] = useState('')
  const navigate = useNavigate();
  const location = useLocation();
  const _idPersona = params.id;
  const _action = params.action;
  const { state } = location;
  const [openDocumentosDialog, setOpenDocumentosDialog] = useState(false);
  const [openTelefonosDialog, setOpenTelefonosDialog] = useState(false);
  const [openProfesionesDialog, setOpenProfesionesDialog] = useState(false);
  const [openDomiciliosDialog, setOpenDomiciliosDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [enableDocumentosButton, setEnableDocumentosButton] = useState(true);
  const [enableTelefonosButton, setEnableTelefonosButton] = useState(true);
  const [enableProfesionesButton, setEnableProfesionesButton] = useState(true);
  const [enableDomiciliosButton, setEnableDomiciliosButton] = useState(true);


  const capitalizar = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  //
  // ################################################################################
  //
  const seleccionarPersona = (currentRowsSelected, allRowsSelected, rowsSelected) => {
    setPersonaelected(rowsSelected);
  }

  //
  // ################################################################################ 
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueAutoCompleteMedioDeCobro({ id: "", label: "" });
    setInputValueAutoCompleteMedioDeCobro("");
    setTotalRowsCount(0);
    setPersona([]);
    setPersonaelected([])
    setTipoMovimiento("todos");
  };


  const handleVolver = () => {
    navigate('/personas/persona-fisica-historial-table')
  };


  //
  // ################################################################################
  //
  const handleBuscar = async () => {
    load(_idPersona);
  };

  const handleDateChange = (fecha) => {
    setSearchData({
      ...searchData,
      fecha_nacimiento: fecha,
    });
  };




  //
  // ################################################################################
  //
  const load = async (idPersona) => {
    setIsDoingSomething(true);
    const response = await getPersonaHistoryById(idPersona)
    setIsDoingSomething(false);

    if (response.ok) {
      let _persona = response.data.data;

      if (_persona.sexo_registrado_nacimiento === 'm') {
        _persona.sexo_registrado_nacimiento = 'MASCULINO'
      }
      else if (_persona.sexo_registrado_nacimiento === 'f') {
        _persona.sexo_registrado_nacimiento = 'FEMENINO'
      }
      else {
        _persona.sexo_registrado_nacimiento = ''
      }

      if (_persona.genero === 'm') {
        _persona.genero = 'MASCULINO'
      }
      else if (_persona.genero === 'f') {
        _persona.genero = 'FEMENINO'
      }
      else {
        _persona.genero = ''
      }

      if (_persona.documentos && _persona.documentos.length > 0) {

        if (_persona.documentos[0]['tipo']) {
          _persona.tipoDocumento = _persona.documentos[0]['tipo']
        }
        if (_persona.documentos[0]['numero']) {
          _persona.numeroDocumento = _persona.documentos[0]['numero']
        }
      }

      if (_persona.fecha_nacimiento) {
        // dar formato a la fecha de dd-mm-yyyy con 2 digitos para el dia y mes y 4 digitos para el año
        let _fecha = new Date(_persona.fecha_nacimiento)
        let _dia = _fecha.getDate().toString().padStart(2, '0')
        let _mes = (_fecha.getMonth() + 1).toString().padStart(2, '0')
        let _anio = _fecha.getFullYear()
        _persona.fecha_nacimiento = _dia + '-' + _mes + '-' + _anio
      }

      if (_persona.fecha_actualizacion) {
        // dar formato a la fecha de dd-mm-yyyy con 2 digitos para el dia y mes y 4 digitos para el año minutos y segundos
        let _fecha = new Date(_persona.fecha_actualizacion)
        let _dia = _fecha.getDate().toString().padStart(2, '0')
        let _mes = (_fecha.getMonth() + 1).toString().padStart(2, '0')
        let _anio = _fecha.getFullYear()
        let _hora = _fecha.getHours().toString().padStart(2, '0')
        let _minutos = _fecha.getMinutes().toString().padStart(2, '0')
        let _segundos = _fecha.getSeconds().toString().padStart(2, '0')
        _persona.fecha_actualizacion = _dia + '-' + _mes + '-' + _anio + ' ' + _hora + ':' + _minutos + ':' + _segundos

      }

      if (_persona.documentos && _persona.documentos.length > 0) {
        setSearchData({
          ...searchData,
          documentos: _persona.documentos.length,
          tipoDocumento: _persona.tipoDocumento,
          numeroDocumento: _persona.numeroDocumento,
        });
      }
      if (_persona.profesiones && _persona.profesiones.length > 0) {
        setSearchData({
          ...searchData,
          profesiones: _persona.profesiones.length,
          descripcionProfesion: _persona.profesiones[0].descripcion,
        });
      }

      if (_persona.telefonos && _persona.telefonos.length > 0) {
        setSearchData({
          ...searchData,
          telefonos: _persona.telefonos.length,
          telefono: _persona.telefonos[0].numero,
        });
      }

      if (_persona.domicilios && _persona.domicilios.length > 0) {
        setSearchData({
          ...searchData,
          domicilios: _persona.domicilios.length,
          domicilio: _persona.domicilios[0].descripcion,
        });
      }
      if (_action === 'new') {
        setSearchData(initialSearchData);
      } else {
        setSearchData(_persona);
      }

    }
    else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
    }

  }

  //
  // ################################################################################
  // Funcion para guardar los datos
  const handleSave = async () => {
    console.log('estoy en guardar')
    // valido los datos
    if (!searchData.apellido) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar el apellido',
      });
      setShowMessage(true);
      return;
    }

    if (searchData.apellido.length > 30) {
      setMessage({
        severity: 'error',
        messageText: 'El apellido no debe tener más de 30 caracteres',
      });
      setShowMessage(true);
      return;
    }

    if (!searchData.nombre) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar el nombre',
      });
      setShowMessage(true);
      return;
    }

    if (searchData.nombre.length > 30) {
      setMessage({
        severity: 'error',
        messageText: 'El nombre no debe tener más de 30 caracteres',
      });
      setShowMessage(true);
      return;
    }

    if (!searchData.sexo_registrado_nacimiento) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar el sexo registrado al nacer',
      });
      setShowMessage(true);
      return;
    }

    if (!searchData.genero) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar el género',
      });
      setShowMessage(true);
      return;
    }

    if (!/^\d{11}$/.test(searchData.cuit)) {
      setMessage({
        severity: 'error',
        messageText: 'El CUIT debe contener solo números y tener 11 caracteres de largo',
      });
      setShowMessage(true);
      return;
    }

    if (!/^\d{11}$/.test(searchData.cuil)) {
      setMessage({
        severity: 'error',
        messageText: 'El CUIL debe contener solo números y tener 11 caracteres de largo',
      });
      setShowMessage(true);
      return;
    }

    if (!searchData.email) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar el correo electrónico',
      });
      setShowMessage(true);
      return;
    }

    if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(searchData.email)) {
      setMessage({
        severity: 'error',
        messageText: 'El correo electrónico no tiene un formato válido',
      });
      setShowMessage(true);
      return;
    }

    if (!searchData.fecha_nacimiento) {
      setMessage({
        severity: 'error',
        messageText: 'Debe ingresar la fecha de nacimiento',
      });
      setShowMessage(true);
      return;
    }

    const fechaNacimiento = new Date(searchData.fecha_nacimiento);
    const hoy = new Date();

    if (fechaNacimiento > hoy) {
      setMessage({
        severity: 'error',
        messageText: 'La fecha de nacimiento no puede ser mayor que hoy',
      });
      setShowMessage(true);
      return;
    }

  }

  //
  // ################################################################################
  // cuando se carga el componente
  //
  useEffect(() => {
    if (_action === 'view') {
      nameItemsText = "Historial de Persona";
      load(_idPersona);
    } else
      if (_action === 'edit') {
        nameItemsText = "Editar Persona Física Historial";
        load(_idPersona);
      }
  }, [currentPage, rowsPerPage]);


  //
  // ################################################################################
  //manejo de los Apertura dialogos de documentos, telefonos, profesiones y domicilios

  const handleDocumentosDialog = () => {
    setOpenDocumentosDialog(true);
    setItemCrud(searchData.documentos)
    setActionCrud('view')
  }
  const handleTelefonosDialog = () => {
    setOpenTelefonosDialog(true);
    setItemCrud(searchData.telefonos)
    setActionCrud('view')

  }
  const handleProfesionesDialog = () => {
    setOpenProfesionesDialog(true);
    setItemCrud(searchData.profesiones)
    setActionCrud('view')


  }
  const handleDomiciliosDialog = () => {
    setOpenDomiciliosDialog(true);
    setItemCrud(searchData.domicilios)
    setActionCrud('view')

  }

  //
  // ################################################################################
  // manejo de los Apertura dialogos de documentos, telefonos, profesiones y domicilios
  const handleCloseDocumentosDialog = () => {
    setOpenDocumentosDialog(false);
  };
  const handleCloseTelefonosDialog = () => {
    setOpenTelefonosDialog(false);
  }
  const handleCloseProfesionesDialog = () => {
    setOpenProfesionesDialog(false);
  }
  const handleCloseDomiciliosDialog = () => {
    setOpenDomiciliosDialog(false);
  }

  //
  // ################################################################################
  // 


  return (
    <Box sx={{ flexGrow: 1, p: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: '800px',
          maxHeight: '100%',
          width: '100%',
          m: 'auto',
          boxSizing: 'border-box',
          // backgroundColor: grey[100]
          backgroundColor: '#f0f0f1'

        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 3 }}>
              <Typography variant="h4" gutterBottom>
                {nameItemsText}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <Typography variant="h5" gutterBottom>
                {searchData.apellido && searchData.nombre ? (searchData.apellido + ' ' + searchData.nombre).toUpperCase() : ''}
              </Typography>
            </Box>
          </Grid>
          {/* <Grid item xs={12} sm={6} lg={1}></Grid> */}

          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="Apellido"
              variant="outlined"
              size="small"
              name="apellido"
              value={searchData.apellido?.toUpperCase() || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view', autoComplete: 'off' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="Nombre"
              variant="outlined"
              size="small"
              name="nombre"
              value={searchData.nombre?.toUpperCase() || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view', autoComplete: 'off' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="CUIL"
              variant="outlined"
              size="small"
              name="cuil"
              value={searchData.cuil || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view' }}
            />
          </Grid>

          {(searchData.documentos?.length > 1 && _action !== "view") && (


            <Grid item xs={12} sm={6} lg={6}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                onClick={handleDocumentosDialog}
                disabled={searchData.documentos?.length === 0 && _action === 'view'}
                startIcon={searchData.documentos?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
              >
                {searchData.documentos?.length === 0 ? 'Agregar Documentos' : 'Ver Documentos'}
              </Button>
            </Grid>
          )}

          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="CUIT"
              variant="outlined"
              size="small"
              name="cuit"
              value={searchData.cuit || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view' }}
            />
          </Grid>

          <Grid item xs={12} md={12} lg={6}>
            <TextField
              inputProps={{
                autoComplete: "off",
              }}
              id="sexoRegistradoNacimiento"
              label="Sexo Registrado al Nacer"
              variant="outlined"
              fullWidth
              size="small"
              name="sexoRegistradoNacimiento"
              onChange={handleChange}
              value={searchData.sexo_registrado_nacimiento}
              InputProps={{ readOnly: true, autoComplete: 'off' }}
            />
          </Grid>

          <Grid item xs={12} md={12} lg={6}>
            <TextField
              inputProps={{
                autoComplete: "off",
              }}
              id="genero"
              label="Género"
              variant="outlined"
              fullWidth
              size="small"
              name="genero"
              onChange={handleChange}
              value={searchData.genero}
              InputProps={{ readOnly: true, autoComplete: 'off' }}
            />
          </Grid>

          {/* Fecha de Nacimiento */}
          <Grid item xs={12} md={12} lg={6}>
            <TextField
              inputProps={{
                autoComplete: "off",
              }}
              id="fechaNacimiento"
              label="Fecha de Nacimiento"
              variant="outlined"
              fullWidth
              size="small"
              name="fechaNacimiento"
              onChange={handleChange}
              value={selectedDate}
              InputProps={{ readOnly: true, autoComplete: 'off' }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <TextField
              sx={{ width: "100%" }}
              inputProps={{
                autoComplete: "off",
                readOnly: _action === 'view'
              }}
              id="email"
              label="Correo Electrónico"
              variant="outlined"
              size="small"
              name="email"
              value={searchData.email ? searchData.email : ' '}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleTelefonosDialog}
              disabled={searchData.telefonos?.length === 0 && _action === 'view'}
              startIcon={searchData.telefonos?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
            >
              {searchData.telefonos?.length === 0 ? 'Agregar Teléfonos' : 'Ver Teléfonos'}
            </Button>
          </Grid>
          {/* Estado Civil */}
          <Grid item xs={12} sm={6} lg={6}>
            <TextField
              fullWidth
              label="Estado Civil"
              variant="outlined"
              size="small"
              name="estado_civil"
              value={searchData.estado_civil?.toUpperCase() || ''}
              onChange={handleChange}
              InputProps={{ readOnly: _action === 'view' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} lg={6}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleProfesionesDialog}
              disabled={searchData.profesiones?.length === 0 && _action === 'view'}
              startIcon={searchData.profesiones?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
            >
              {searchData.profesiones?.length === 0 ? 'Agregar Profesiones' : 'Ver Profesiones'}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} lg={6}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleDomiciliosDialog}
              disabled={searchData.domicilios?.length === 0 && _action === 'view'}
              startIcon={searchData.domicilios?.length === 0 ? <AddIcon /> : <VisibilityIcon />}
            >
              {searchData.domicilios?.length === 0 ? 'Agregar Domicilios' : 'Ver Domicilios'}
            </Button>
          </Grid>

          {searchData.fecha_actualizacion && (

            <Grid item xs={12} md={6} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  readOnly: _action === 'view'
                }}
                id="fecha_actualizacion"
                label="Fecha de Actualización"
                variant="outlined"
                size="small"
                name="fecha_actualizacion"
                value={searchData.fecha_actualizacion ? searchData.fecha_actualizacion : ' '}
                onChange={handleChange}
              />
            </Grid>
          )}
          {
            searchData.fecha_fallecimiento && (
              <Grid item xs={12} md={6} lg={6}  >
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: _action === 'view'
                  }}
                  id="fecha_fallecimiento"
                  label="Fecha de Fallecimiento"
                  variant="outlined"
                  size="small"
                  name="fecha_fallecimiento"
                  value={searchData.fecha_fallecimiento ? searchData.fecha_fallecimiento : ' '}
                  onChange={handleChange}
                />
              </Grid>
            )

          }
        </Grid>
        <Grid container spacing={1} sx={{ mt: 4, justifyContent: "flex-end" }}>

          {_action === 'edit' && (

            <Grid item xs={12} md={2} lg={2}>
              <Button
                sx={{ mr: 1, width: "100%" }}
                variant="outlined"
                onClick={handleLimpiar}
                startIcon={<CleaningServicesIcon />}
              >
                Limpiar
              </Button>
            </Grid>)}

          <Grid item xs={12} md={2} lg={3}>
            <Button
              sx={{ width: "100%", mt: 4 }}
              variant="outlined"
              onClick={handleVolver}
              startIcon={<KeyboardReturn />}
            >
              Volver
            </Button>
          </Grid>
          {_action !== 'view' && (

            <Grid item xs={12} md={6} lg={6}>
              <Button
                sx={{ mr: 1, width: "100%" }}
                variant="contained"
                onClick={handleSave}
                startIcon={<Save />}
                disabled={!searchData.nombre || !searchData.apellido || !searchData.sexo_registrado_nacimiento || !searchData.documentos || !searchData.fecha_nacimiento}
              >
                Guardar
              </Button>
            </Grid>)}
        </Grid>
      </Paper>

      {/* dialogo de Documentos */}
      {
        openDocumentosDialog && (
          <DocumentosDialog
            onSave={handleDocumentosDialog}
            onClose={handleCloseDocumentosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.documentos}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Telefonos */}
      {
        openTelefonosDialog && (
          <TelefonosDialog
            onSave={handleTelefonosDialog}
            onClose={handleCloseTelefonosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.telefonos}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Profesiones */}
      {
        openProfesionesDialog && (
          <ProfesionesDialog
            onSave={handleProfesionesDialog}
            onClose={handleCloseProfesionesDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.profesiones}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* dialogo de Domicilios */}
      {
        openDomiciliosDialog && (
          <DomiciliosDialog
            onSave={handleDomiciliosDialog}
            onClose={handleCloseDomiciliosDialog}
            itemCrud={itemCrud}
            itemsCrud={searchData.domicilios}
            actionCrud={actionCrud}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
            _idPersona={_idPersona}
          />
        )
      }

      {/* >>>> Messages */}
      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }

    </Box>
  );
};

export default PersonaFisicaHistorial;
